import { render, staticRenderFns } from "./PortalDate.vue?vue&type=template&id=8717c674&scoped=true&"
import script from "./PortalDate.vue?vue&type=script&lang=ts&"
export * from "./PortalDate.vue?vue&type=script&lang=ts&"
import style0 from "./PortalDate.vue?vue&type=style&index=0&id=8717c674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8717c674",
  null
  
)

export default component.exports